import {createApp} from "vue";

const axios = require('axios');


export default {
    name: 'service-packages',
    _el: null,

    init() {
        this._el = document.getElementById('js_servicePackages');

        if (this._el) {
            this.run();
        }
    },

    run() {
        const queryString = window.location.search;

        let regNumber = null;
        let firstname = null;
        let lastname = null;
        let email = null;
        let phone = null;
        let street = null;
        let zipcode = null;
        let city = null;
        let mileage = null;

        if (queryString.search('test=reg_number') != -1) {
            regNumber = 'st93657';
            firstname = 'Ola';
            lastname = 'Nordmann';
            email = 'test@example.com';
            phone = '12345679';
            street = 'Kanonveien 9';
            zipcode = '0001';
            city = 'Olso';
            mileage = '123456';
        }

        createApp({
            delimiters: ['@{', '}'],

            data()
            {
                return {
                    status: 'ready',
                    aboutProduct: null,
                    cart: [],
                    email: null,
                    equipment: [],
                    equipmentDetailsToggled: false,
                    brandList: [],
                    brand: '',
                    city: city,
                    classAttachment: '',
                    equipmentList: [],
                    gdpr: null,
                    fuel: "",
                    host: null,
                    isFormExtended: false,
                    item: null,
                    message: null,
                    mileage: mileage,
                    model: null,
                    firstname: firstname,
                    lastname: lastname,
                    noOfOwners: null,
                    newsletter: null,
                    phone: phone,
                    resource: '',
                    regNumber: regNumber,
                    registeredAt: null,
                    retailerId: null,
                    street: street,
                    searchResult: null,
                    selectedPackage: null,
                    selectedProducts: [],
                    showSubmit: false,
                    showDialog: false,
                    transmission: "",
                    userId: email,
                    wheelDrive: "",
                    year: null,
                    responseStatus: null,
                    responseMessage: null,
                    zipcode: zipcode,
                    xhrActive: false,
                }
            },

            created() {
                const rootEl = document.getElementById('js_servicePackages');
                this.host = document.querySelector('[name="site_root"]').content;
                this.redirect = window.location.href;

                this.retailerId = !isNaN(rootEl.dataset.retailerid) ? rootEl.dataset.retailerid : '';
                this.resource = rootEl.dataset.resource;
                this.getServicePackages();
                rootEl.classList.add('is-ready');
            },

            computed:
                {
                    basicDetailsClass() {
                        return (this.showSubmit) ? ' toggled ' : '';
                    },

                    extendFormClass() {
                        return this.isFormExtended ? ' active ' : '';
                    },

                    packageProducts() {
                        const items = this.searchResult ?
                            this.searchResult.hits.filter((i) => typeof i.spareparts === 'object' && i.spareparts.length) :
                            [];

                        return items.sort((a, b) => {
                            return a.price_total - b.price_total
                        });
                    },

                    singleProducts() {
                        const items = this.searchResult ?
                            this.searchResult.hits.filter((i) => typeof i.spareparts === 'undefined' || i.spareparts.length === 0) :
                            [];

                        return items;
                    },

                    priceTotal() {
                        const total = this.cart.reduce((accumulator, p) => {
                            return accumulator + p.price_total
                        }, 0);

                        return total;
                    },

                    submitIsDisabled() {
                        const hasCartItems = this.cart.length ? true : false;

                        const readyToSubmit = (hasCartItems && !this.xhrActive);

                        return (!readyToSubmit);
                    },

                },

            methods:
            {
                addToCart(product) {
                    const isPackage = typeof product.spareparts === 'object' && product.spareparts.length;

                    const removePackge = (isPackage && this.selectedPackage && product.id == this.selectedPackage);

                    let removeFromCart = false;
                    // reset cart items if product is package and new
                    if (isPackage && removePackge === false) {
                        this.cart = []; // empty cart when changing resource
                        this.selectedProducts = [];
                        // remove selected packge from cart
                    } else if (isPackage && removePackge === true) {
                        removeFromCart = this.isInCart(product);
                        this.selectedPackage = null;
                        // handle single product
                    } else {
                        removeFromCart = this.isInCart(product);
                    }

                    if (removeFromCart === false) {
                        // console.log('add to cart: '+product.id);
                        this.cart.push(product);
                    } else {
                        // console.log('remove to cart: '+product.id);
                        this.cart.splice(removeFromCart, 1);
                    }

                    this.extendForm();
                },

                extendForm() {
                    this.isFormExtended = true;
                },

                fieldId(product) {
                    return 'pid-' + product.id;
                },

                hasCampaign(product) {
                    const hasCampaignPrice = (typeof product.campaign_price === 'number'
                        && product.campaign_price > 0
                        && product.campaign_price < product.price_total);

                    const now = new Date();
                    const campignFrom = (product.campaign_from) ? new Date(product.campaign_from) : null;
                    const campaignTo = (product.campaign_to) ? new Date(product.campaign_to) : null;

                    let isCampaignTime = true;

                    if (campignFrom) {
                        isCampaignTime = campignFrom <= now;
                    }

                    if (campaignTo) {
                        isCampaignTime = campaignTo >= now;
                    }

                    return (hasCampaignPrice && isCampaignTime);
                },

                getPriceTotalCssClass(product) {
                    return this.hasCampaign(product) ? ' discount-price ' : '';
                },

                calcDiscountPercentage(product) {
                    const diff = product.price_total - product.campaign_price;
                    const percentage = diff / product.price_total * 100;

                    return '-' + Number.parseInt(percentage) + '%';
                },

                formatPrice(price) {
                    let total = parseInt(price);

                    if (total == 0) {
                        return 'på forespørsel';
                    } else {
                        return total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
                    }
                },

                getSelectedLabel(elementId) {
                    const el = document.getElementById(elementId);

                    let label = (el && el.selectedIndex >= 0 && typeof el.options[el.selectedIndex] !== 'undefined') ?
                        el?.options[el.selectedIndex]?.text :
                        '';

                    return (label.toLowerCase() !== 'velg') ? label : '';
                },

                isActiveResource(resource) {
                    return resource === this.resource ? ' active ' : '';
                },

                isInCart(product) {
                    let positionInCart = this.cart.findIndex((object) => object.id == product.id);
                    // console.log('is in cart: '+product.id+ ' => '+positionInCart);

                    let isInCart = (Number.isInteger(positionInCart) && positionInCart != -1) ?
                        positionInCart :
                        false;

                    return isInCart;
                },

                isSelectedProduct(product) {
                    return this.isInCart(product) !== false ? ' active ' : ' not-active ';
                },

                prepareData() {
                    const token = document.querySelector('[name="CRAFT_CSRF_TOKEN"]');

                    const bodyFormData = new FormData();
                    const productData = {
                        'brand_name': this.getSelectedLabel('brand'),
                        'model': this.model,
                        'reg_number': this.regNumber,
                    };

                    this.cart.forEach((i) => {
                        productData[i.name_no] = this.formatPrice(i.price_total);
                    });

                    bodyFormData.append('first_name', this.firstname);
                    bodyFormData.append('last_name', this.lastname);
                    bodyFormData.append('city', this.city);
                    bodyFormData.append('email', this.userId);
                    bodyFormData.append('gdpr', (this.gdpr) ? 1 : 0);
                    bodyFormData.append('phone', this.phone);
                    bodyFormData.append('data', JSON.stringify(productData));
                    bodyFormData.append('honeypot', this.email ? this.email : '');
                    bodyFormData.append('message', this.message);
                    bodyFormData.append('retailerId', this.retailerId);
                    bodyFormData.append('redirect', this.redirect);
                    bodyFormData.append('street', this.street);
                    bodyFormData.append('subject', 'Servicepakker');
                    bodyFormData.append('type', 'service');
                    bodyFormData.append('zipcode', this.zipcode);

                    if (this.newsletter) {
                        bodyFormData.append('newsletter', '1');
                    }

                    // console.log('PRODUCT DATA');
                    // console.log(productData);
                    // console.log(bodyFormData);
                    return bodyFormData;
                },

                onSubmit() {
                    this.responseStatus = '';
                    this.responseMessage = '';
                    this.classAttachment = '';

                    if (this.submitIsDisabled === false) {
                        // this.xhrActive = true;
                        const url = '/actions/mm/mail/store';
                        const postData = this.prepareData();
                        this.restPost(url, postData, 'onSubmit__callback', 'onSubmit__error');
                    }
                },

                onSubmit__callback(response) {
                    if (typeof response === 'object' && typeof response.data === 'object') {
                        this.responseStatus = 'ok';
                        this.responseMessage = response.data.message;
                    }

                    this.scrollToForm();
                    this.xhrActive = false;
                },

                onSubmit__error(error) {
                    console.log('onSubmit__error');
                    console.log(error);
                    this.responseStatus = 'error';
                    this.responseMessage = error;
                    this.scrollToForm();
                    this.xhrActive = false;
                },

                scrollToForm() {
                    const el = document.getElementById('js_servicePackages');
                    el.style.top = (el.offsetTop - 16) + "px";
                    el.scrollIntoView({block: "start", behavior: "smooth"});
                },

                showIncludedProducts(servicePkg) {
                    const includedProducts = this.searchResult.hits.filter((i) => servicePkg.spareparts.includes(i.id));

                    const nameList = includedProducts.map((i) => i.name_no);

                    return nameList.join(', ');
                },

                getSelectedPackageObject() {
                    const selectedPackage = (this.selectedPackage) ?
                        this.searchResult.hits.find((i) => i.id == this.selectedPackage) :
                        null;

                    return selectedPackage;
                },

                isProductSelectable(product) {
                    const selectedPackage = this.getSelectedPackageObject();

                    return (selectedPackage && selectedPackage.spareparts.includes(product.id)) ?
                        false :
                        true;
                },

                productRowClasses(product, key) {
                    // check if product is added in cart
                    const isInCart = this.isInCart(product);

                    // check if product is added as part of a selected package
                    const selectedPackage = this.getSelectedPackageObject();
                    const addedAsPartOfPackage = (selectedPackage && selectedPackage.spareparts.includes(product.id)) ? true : false;

                    const statusClass = (isInCart !== false || addedAsPartOfPackage) ? ' active ' : '  not-active ';
                    const oddOrEvenClass = key % 2 === 0 ? ' even ' : ' odd ';

                    return `${statusClass} ${oddOrEvenClass} key-${key}`;
                },

                findRegNumber() {
                    // console.log('findRegNumber');
                    if (typeof this.regNumber === 'string' && this.regNumber.length) {
                        this.regNumber = this.regNumber.replaceAll(' ', '');
                        const endpoint = '/actions/ck/price-estimate/get-regnumber';
                        const queryArgs = {reg_number: this.regNumber};

                        this.rest(endpoint, queryArgs, 'findRegNumber__callback');
                    }

                    this.showSubmit = true;
                },

                findRegNumber__callback(response) {
                    // console.log("findRegNumber__calback");
                    // console.log(response.data);
                    if (response.data.item && typeof response.data.item === 'object') {
                        this.item = response.data.item;
                        this.year = this.item.year;
                        this.model = this.item.modell;
                        this.fuel = this.item.drivst;
                        this.registeredAt = this.item.registered_at;
                        this.transmission = this.item.transmission;
                        this.brand = this.item.brand.id;
                        this.brandList = this.item.brandList;

                        // check if object is compatible with active resource
                        if (this.item.resource !== this.resource) {
                            this.responseMessage = 'Ditt kjøretøy ' +
                                '(' + this.rtl(this.item.resource) + ')' +
                                ' passer ikke til utvalget' +
                                '(' + this.rtl(this.resource) + ')';
                            this.responseStatus = 'error';

                            this.scrollToForm();
                        }
                    } else {
                        this.responseStatus = 'error';
                        this.responseMessage = 'Registreringsnummert ble ikke funnet';
                        this.scrollToForm();
                    }
                },

                rtl(resource) {
                    // console.log('resource to label '+resource);
                    let label = '';
                    if (resource === 'caravans') {
                        label = 'bobil';
                    } else if (resource === 'caravan-trailers') {
                        label = 'campingvogn';
                    } else if (resource === 'cars') {
                        label = 'bil';
                    } else if (resource === 'atv') {
                        label = 'atv';
                    } else if (resource === 'motorcycles') {
                        label = 'motorsykkel';
                    } else {
                        label = resource;
                    }

                    return label;
                },

                getServicePackages() {
                    // console.log('getServicePackages('+this.resource+')');
                    this.resetSelection();
                    if (this.resource.length) {
                        const endpoint = '/actions/ck/service-packages/index';
                        const queryArgs = {resource: this.resource};

                        this.rest(endpoint, queryArgs, 'getServicePackages__callback');
                    }
                },

                getServicePackages__callback(response) {
                    if (typeof response.data === 'object' && response.status === 200) {
                        this.searchResult = response.data;
                    }
                },

                rest(endpoint, queryArgs, callback) {
                    this.responseStatus = this.responseMessage = null;

                    let queryString = "";
                    for (var i in queryArgs) {
                        queryString += i + "=" + queryArgs[i] + "&";
                    }
                    const url = this.host + endpoint + "?" + queryString;

                    axios.get(url)
                        .then(this[callback])
                        .catch(function (error) {
                        });
                },

                restPost(endpoint, queryArgs, callback, callback__error) {
                    const headers = {"Content-Type": "multipart/form-data"};

                    const url = this.host + endpoint;
                    axios.post(url, queryArgs, headers)
                        .then(this[callback])
                        .catch(this[callback__error]);
                },

                resetSelection() {
                    this.cart = []; // empty cart when changing resource
                    this.selectedPackage = null;
                    this.selectedProducts = [];
                },

                showModal(product) {
                    this.aboutProduct = product;
                    this.showDialog = true;
                },

                hideModal() {
                    this.showDialog = false;
                    this.aboutProduct = null;
                },

                maybeHideModal(event) {
                    if (event.target.classList.contains('te-dialog')) {
                        this.hideModal();
                    }
                },

            }
        }).mount('#js_servicePackages');

    }
}